import { forwardRef, useEffect } from "react";
import { BlogCardWireframe } from "./BlogCardWireframe";

interface InfiniteScrollLoaderProps {
  loading: boolean;
  hasMore: boolean;
}

export const InfiniteScrollLoader = forwardRef<HTMLDivElement, InfiniteScrollLoaderProps>(
  ({ loading, hasMore }, ref) => {
    console.log(`InfiniteScrollLoader: loading=${loading}, hasMore=${hasMore}`);
    
    useEffect(() => {
      console.log(`InfiniteScrollLoader effect: loading=${loading}, hasMore=${hasMore}`);
    }, [loading, hasMore]);
    
    // Always render the loader component when hasMore is true, even if not loading
    // This ensures the intersection observer has something to observe
    
    return (
      <div 
        ref={ref} 
        className="w-full mb-10" 
        data-testid="infinite-scroll-loader"
        style={{ 
          border: process.env.NODE_ENV === 'development' ? '1px dashed #ccc' : 'none', // Visual aid in dev mode
        }}
      >
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.from({ length: 6 }).map((_, index) => (
              <BlogCardWireframe key={index} />
            ))}
          </div>
        ) : (
          <div className="py-8 flex justify-center items-center" style={{ minHeight: '200px' }}>
            {hasMore ? (
              <span className="text-sm text-muted-foreground">
                Scorri per altri articoli
              </span>
            ) : (
              <span className="text-sm text-muted-foreground">
                Non ci sono altri articoli
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
);

InfiniteScrollLoader.displayName = "InfiniteScrollLoader";
